// Random ids made in the browser for one action (a Check, a form submission), so a request that is sent again after a
// lost answer is recognised by the server and never counted twice. Call only in event handlers or effects.

export const newRequestId = (): string => {
    const cryptoApi = typeof globalThis.crypto !== 'undefined' ? globalThis.crypto : null

    if (cryptoApi && typeof cryptoApi.randomUUID === 'function') return cryptoApi.randomUUID()

    const bytes = new Uint8Array(16)

    if (cryptoApi) cryptoApi.getRandomValues(bytes)
    else for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256)

    return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
}
